"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNull = void 0;
exports.isNull = (value) => value === null;
//# sourceMappingURL=is-null.js.map